import { gql } from 'graphql-request'

export const IMPORTAR_GRUPO_USUARIOS = gql`
  mutation ImportarGrupoUsuariosMutation {
    importarGrupoUsuarios
  }
`
